module.exports = __webpack_public_path__ + "img/policyComment-cover.9bc0c546.png";